// API calls
import {
  fetchAllPrograms,
  fetchAllProgramsQuestions,
} from "../../redux/actions/programs/programsData";
import {
  fetchAllClassicalLastQuestions,
  fetchAllClassicalQuestions,
  fetchAllContests,
  fetchAllTournaments,
  fetchAllUnassignedClassicalQuestions,
} from "../../redux/actions/tournaments/tournamentData";
// Stores
import { setProgramSliceData } from "../../redux/features/programs/programsSlice";
import { setTournamentSliceData } from "../../redux/features/tournaments/tournamentSlice";

// Fetch programs
export const fetchProgramsList = (
  dispatch,
  progPage = 1,
  progPageSize = 10,
  init = false,
  userOrganization,
  navbarSearch,
  sortOrderBy = "",
  selectedComplexityFilter = [],
  selectedRoleFilter = [],
  selectedCategoryFilter = [],
  selectedLearnPointFilter = []
) => {
  if (userOrganization) {
    dispatch(setProgramSliceData({ type: "programListPage", data: progPage }));
    dispatch(
      setProgramSliceData({ type: "programListPageSize", data: progPageSize })
    );
    dispatch(
      fetchAllPrograms({
        page: progPage,
        page_size: progPageSize,
        ordering: sortOrderBy,
        complexity: selectedComplexityFilter.toString(),
        roles: selectedRoleFilter.toString(),
        category: selectedCategoryFilter.toString(),
        learningPoint: selectedLearnPointFilter.toString(),
        userOrganization,
        search:
          !init && navbarSearch && navbarSearch.length > 1 ? navbarSearch : "",
      })
    );
  }
};

// Fetch tournaments
export const fetchContestList = (
  dispatch,
  page = 1,
  pageSize = 10,
  userOrganization,
  sortOrderBy,
  navbarSearch,
  selectedOrgFilter = [],
  selectedStatusFilter = "",
  selectedContestTypeFilter = ""
) => {
  if (userOrganization) {
    dispatch(setTournamentSliceData({ type: "contestListPage", data: page }));
    dispatch(
      setTournamentSliceData({
        type: "contestListPageSize",
        data: pageSize,
      })
    );
    dispatch(
      fetchAllContests({
        page: page,
        page_size: pageSize,
        ordering: sortOrderBy,
        userOrganization,
        organization_name: selectedOrgFilter.toString(),
        status: selectedStatusFilter,
        tournament_type: selectedContestTypeFilter,
        search: navbarSearch ? navbarSearch : "",
      })
    );
  }
};

//Fetch Contests
export const fetchTournamentsList = (
  dispatch,
  page = 1,
  pageSize = 10,
  userOrganization,
  sortOrderBy,
  navbarSearch,
  selectedOrgFilter = [],
  selectedRoleFilter = [],
  selectedStatusFilter = "",
  selectedTournamentTypeFilter = ""
) => {
  if (userOrganization) {
    dispatch(
      setTournamentSliceData({ type: "tournamentListPage", data: page })
    );
    dispatch(
      setTournamentSliceData({
        type: "tournamentListPageSize",
        data: pageSize,
      })
    );
    dispatch(
      fetchAllTournaments({
        page: page,
        page_size: pageSize,
        ordering: sortOrderBy,
        userOrganization,
        organization_name: selectedOrgFilter.toString(),
        roles: selectedRoleFilter.toString(),
        status: selectedStatusFilter,
        tournament_type: selectedTournamentTypeFilter,
        search: navbarSearch ? navbarSearch : "",
      })
    );
  }
};

// Fetch Tournament Classical Questions
export const fetchRecommendedClassicalQuestionsList = (
  dispatch,
  userOrganization,
  classicalUnassignedQuesPage,
  classicalUnassignedQuesPageSize,
  navbarSearch,
  selectedCategoryFilter = [],
  selectedLearnPointFilter = [],
  selectedQuesTypeFilter = []
) => {
  dispatch(
    fetchAllUnassignedClassicalQuestions({
      page: classicalUnassignedQuesPage ? classicalUnassignedQuesPage : 1,
      page_size: classicalUnassignedQuesPageSize
        ? classicalUnassignedQuesPageSize
        : 10,
      userOrganization,
      module: "WM",
      search: navbarSearch && navbarSearch.length > 2 ? navbarSearch : "",
      category: selectedCategoryFilter.toString(),
      learningPoint: selectedLearnPointFilter.toString(),
      type: selectedQuesTypeFilter.toString(),
    })
  );
};
export const fetchAllClassicalQuestionsList = (
  dispatch,
  userOrganization,
  classicalQuesPage,
  classicalQuesPageSize,
  navbarSearch,
  selectedCategoryFilter = [],
  selectedLearnPointFilter = [],
  selectedQuesTypeFilter = [],
  selectedLastAssignedDate = {}
) => {
  dispatch(
    fetchAllClassicalQuestions({
      page: classicalQuesPage ? classicalQuesPage : 1,
      page_size: classicalQuesPageSize ? classicalQuesPageSize : 10,
      userOrganization,
      search: navbarSearch && navbarSearch.length > 2 ? navbarSearch : "",
      category: selectedCategoryFilter.toString(),
      learningPoint: selectedLearnPointFilter.toString(),
      type: selectedQuesTypeFilter.toString(),
      lastAssignedDate: selectedLastAssignedDate,
    })
  );
};
export const fetchLastClassicalQuestionsList = (
  dispatch,
  userOrganization,
  classicalLastQuesPage,
  classicalLastQuesPageSize,
  navbarSearch,
  selectedCategoryFilter = [],
  selectedLearnPointFilter = [],
  selectedQuesTypeFilter = [],
  selectedLastAssignedDate = {}
) => {
  dispatch(
    fetchAllClassicalLastQuestions({
      page: classicalLastQuesPage ? classicalLastQuesPage : 1,
      page_size: classicalLastQuesPageSize ? classicalLastQuesPageSize : 10,
      userOrganization,
      search: navbarSearch && navbarSearch.length > 2 ? navbarSearch : "",
      category: selectedCategoryFilter.toString(),
      learningPoint: selectedLearnPointFilter.toString(),
      type: selectedQuesTypeFilter.toString(),
      lastAssignedDate: selectedLastAssignedDate,
    })
  );
};

// Fetch program questions
export const fetchProgramQuestions = (
  dispatch,
  page = 1,
  pageSize = 10,
  userOrganization,
  sortOrderBy,
  selectedStatusFilter = null,
  selectedModuleFilter = [],
  selectedRoleFilter = [],
  selectedCategoryFilter = [],
  selectedLearnPointFilter = [],
  selectedQuestionTagFilter = [],
  navbarSearch
) => {
  dispatch(setProgramSliceData({ type: "programQuesPage", data: page }));
  dispatch(
    setProgramSliceData({ type: "programQuesPageSize", data: pageSize })
  );
  dispatch(
    fetchAllProgramsQuestions({
      page: page,
      page_size: pageSize,
      ordering: sortOrderBy,
      userOrganization,
      status: selectedStatusFilter.toString(),
      modules: selectedModuleFilter.toString(),
      roles: selectedRoleFilter.toString(),
      category: selectedCategoryFilter.toString(),
      learningPoint: selectedLearnPointFilter.toString(),
      questionTags: selectedQuestionTagFilter.toString(),
      search: navbarSearch,
    })
  );
};
